// 네이티브 WebView(JavaScriptChannel) 브릿지를 대체하는 웹 표준 API 유틸

export function callPhone(number) {
	location.href = `tel:${number}`
}

export function openMail(address) {
	location.href = `mailto:${address}`
}

export function openExternal(url) {
	window.open(url, '_blank')
}

// 반환값: 'shared' | 'copied' | 'cancelled' | 'unsupported'
export async function shareOrCopy(url) {
	if (navigator.share) {
		try {
			await navigator.share({ url })
			return 'shared'
		} catch (e) {
			return 'cancelled'
		}
	}
	if (navigator.clipboard && navigator.clipboard.writeText) {
		await navigator.clipboard.writeText(url)
		return 'copied'
	}
	return 'unsupported'
}
